import { createStore } from "solid-js/store"
import type { MapData } from "../types"

// Default bounds (will be populated after fetching map data)
const initialMapData: MapData = {
    bounds: [
        [59.333, 18.052],
        [59.343, 18.075],
    ],
    streets: { type: "FeatureCollection", features: [] },
    buildings: { type: "FeatureCollection", features: [] },
}

export const [mapData, setMapData] = createStore<MapData>(initialMapData)

// Fetch map data from public folder (cached by service worker)
let defaultMapData: { streets: GeoJSON.FeatureCollection; buildings: GeoJSON.FeatureCollection } | null = null

export async function loadMapData() {
    if (defaultMapData) {
        // Already loaded, use cached data
        setMapData({
            bounds: initialMapData.bounds,
            streets: defaultMapData.streets,
            buildings: defaultMapData.buildings,
        })
        return
    }

    try {
        const response = await fetch("/data/default-map.json")
        if (!response.ok) throw new Error(`Failed to fetch map: ${response.status}`)

        defaultMapData = await response.json()
        if (!defaultMapData) return
        setMapData({
            bounds: initialMapData.bounds,
            streets: defaultMapData.streets,
            buildings: defaultMapData.buildings,
        })
    } catch (error) {
        console.error("Failed to load map data:", error)
        // Keep empty map as fallback
    }
}

export function resetMap() {
    if (defaultMapData) {
        setMapData({
            bounds: initialMapData.bounds,
            streets: defaultMapData.streets,
            buildings: defaultMapData.buildings,
        })
    }
}
